import HttpService from '../HttpService'
import { retryCount } from '@/shared/constants/api.constants'
import { formDataGenerator } from '../../api.utils'
import {
  DefaultResponse,
  GetQuotePaymentsResponse,
  GetQuoteResponse,
  PaymentMethod,
} from '@/shared/types/response.types'
import { AxiosResponse } from 'axios'
import { useEnvironment } from '@/shared/composables/useEnvironment'
import { useLocale } from '@/shared/composables/useLocale'

export class QuoteService extends HttpService {
  async getQuote(): Promise<GetQuoteResponse> {
    const { data } = await this.get<GetQuoteResponse>('getvisitorsquote', { retry: retryCount })
    if (data.quoteno) {
      localStorage.setItem('user-payload.quoteno', data.quoteno)
    }
    return data
  }

  async getQuoteDetails(payload: object): Promise<GetQuoteResponse> {
    const { data } = await this.post<AxiosResponse>(
      'visitorquotedetails',
      formDataGenerator(payload),
      { retry: retryCount }
    )
    return data
  }

  updateVisitorsQuote(data: {
    quoteno: string
    inboundquoteno?: string
    inboundproductcode?: string
    inboundschemecode?: string
  }): Promise<DefaultResponse> {
    const { isDevelopment } = useEnvironment()
    const { locale } = useLocale()

    let requestData = data

    if (isDevelopment.value) {
      const redirectCode = locale === 'en' ? 'visitorssuccess' : 'visitorssuccessar'
      // @ts-ignore
      requestData = { ...data, redirectPageCode: redirectCode }
    }
    // @ts-ignore
    return this.post('updatevisitorsquote', formDataGenerator(requestData), { retry: retryCount })
  }

  async getQuotePayments(quoteno: string): Promise<GetQuotePaymentsResponse> {
    const { data } = await this.get<AxiosResponse>('getquotepayments', { params: { quoteno } })
    return data
  }

  async getPaymentOptions(quoteno: string): Promise<PaymentMethod[]> {
    const { data } = await this.get<AxiosResponse>('getvisitorspaymentoptions', {
      params: { quoteno },
    })
    return data.paymentOptionArry
  }

  async getTravelQuote() {
    const { data } = await this.get<AxiosResponse>('gettravelquote', {
      params: { mode: 'visitorsadon' },
    })
    return data
  }
}
